import React from 'react';
import Button from '../Button/Button';

interface PaymentSuccessfulProps {
  setPaymentReference: React.Dispatch<React.SetStateAction<string>>;
  createOrder: (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => Promise<void>;
}

function NoPaymentNeeded({
  setPaymentReference,
  createOrder,
}: PaymentSuccessfulProps) {
  const [blockButton, setBlockButton] = React.useState<boolean>(false);
  const onClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    setPaymentReference('no_reference_needed');
    setBlockButton(true);
    createOrder(e);
  };
  return (
    <div className="w-full flex flex-col justify-center items-center bg-system-100 p-6 rounded-lg gap-5">
      <div className="w-full font-title lg:text-lg text-2xl text-black font-semibold">
        Ha finalizado su compra con éxito
      </div>
      <h1 className="text-neutral-cold-400">
        Ya que su monto total es de 0$, no es necesario realizar ningún pago
      </h1>
      <Button
        type="button"
        disabled={blockButton}
        onClick={onClick}
        className="w-[50%] bg-color-primary-300 hover:bg-color-primary-100 border-solid border border-cold-500 text-system-100 justify-center px-3 font-normal"
      >
        Procesar orden
      </Button>
    </div>
  );
}

export default NoPaymentNeeded;
